
import React, { useEffect } from 'react';
import './Banner.css';

function isValidHTML(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.children.length > 0;
}

export const Banner = () => {
    const BANNER_URL = "https://expleague.blob.core.windows.net/thumb/events-ooo.html"

    const [html, setHtml] = React.useState(null);

    useEffect(() => {
        async function fetchData() {
            const response = await fetch(BANNER_URL);
            if (response.ok) {
                const text = await response.text();

                if (isValidHTML(text)) {
                    setHtml(text);
                }
            }
        }
        fetchData();
    }, []);

    if (!html) { return null; }

    return (
        <div className="banner">
            <div className="contents" dangerouslySetInnerHTML={{ __html: html }} />
        </div>        
    );
};

